module.exports = __webpack_public_path__ + "static/media/welcome-bonus-mobile-header-image.b96afbee.png";